/**
 * Theme JavaScript
 * Garden Center Solutions - GCS Custom Theme
 */

(function($) {
  'use strict';

  // Document Ready
  $(document).ready(function() {
    
    // Initialize Bootstrap tooltips
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
    
    // Smooth scroll for anchor links
    $('a[href^="#"]').on('click', function(e) {
      var target = $(this.getAttribute('href'));
      if(target.length) {
        e.preventDefault();
        $('html, body').stop().animate({
          scrollTop: target.offset().top - 100
        }, 800);
      }
    });
    
    // Add to cart AJAX (optional enhancement)
    $(document).on('submit', 'form[action*="/cart/add"]', function(e) {
      e.preventDefault();
      
      var $form = $(this);
      var $button = $form.find('button[type="submit"]');
      var originalText = $button.text();
      
      $button.prop('disabled', true).text('Adding...');
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $form.serialize(),
        dataType: 'json',
        success: function(item) {
          $button.text('Added!');
          
          // Update cart count
          $.getJSON('/cart.js', function(cart) {
            $('.cart-count').text(cart.item_count);
          });
          
          setTimeout(function() {
            $button.prop('disabled', false).text(originalText);
          }, 2000);
        },
        error: function(xhr, status, error) {
          $button.prop('disabled', false).text(originalText);
          alert('Error adding to cart. Please try again.');
        }
      });
    });
    
    // Mobile menu enhancements
    $('.navbar-toggler').on('click', function() {
      $(this).toggleClass('active');
    });
    
  });

  // Window Load
  $(window).on('load', function() {
    // Remove loading states if any
    $('body').removeClass('loading');
  });

  // Window Scroll
  var lastScroll = 0;
  $(window).on('scroll', function() {
    var currentScroll = $(this).scrollTop();
    
    // Add sticky header class
    if (currentScroll > 100) {
      $('body').addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
    }
    
    lastScroll = currentScroll;
  });

  // Collection Page - View Toggle
  $('.view-btn').on('click', function() {
    var view = $(this).data('view');
    $('.view-btn').removeClass('active');
    $(this).addClass('active');
    
    var $grid = $('#productGrid');
    
    if (view === 'list') {
      $grid.removeClass('row').addClass('list-view');
      $grid.find('.product-grid-item').removeClass('col-6 col-md-4').addClass('col-12');
    } else {
      $grid.addClass('row').removeClass('list-view');
      $grid.find('.product-grid-item').addClass('col-6 col-md-4').removeClass('col-12');
    }
  });
  
  // Collection Page - Sort Functionality
  $('#sortBy').on('change', function() {
    var sortValue = $(this).val();
    var currentUrl = window.location.href;
    var separator = currentUrl.includes('?') ? '&' : '?';
    
    // Remove existing sort_by parameter if present
    currentUrl = currentUrl.replace(/[\?&]sort_by=[^&]+/, '');
    
    // Add new sort parameter
    window.location.href = currentUrl + separator + 'sort_by=' + sortValue;
  });
  
  // Price Range Filter (basic implementation)
  $('#priceRange').on('change', function() {
    var maxPrice = $(this).val();
    $('.price-max').text('$' + maxPrice);
    
    // Filter products by price (basic client-side filter)
    $('.product-grid-item').each(function() {
      var priceText = $(this).find('.price-regular').text().replace('$', '').replace(',', '');
      var price = parseFloat(priceText);
      
      if (price <= maxPrice) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
  
  // Filter Checkboxes
  $('.filter-checkbox input[type="checkbox"]').on('change', function() {
    // This is a basic implementation - you may want to enhance with AJAX
    var filterType = $(this).closest('.sidebar-widget').find('.sidebar-widget-title').text().toLowerCase();
    var filterValue = $(this).val();
    var isChecked = $(this).is(':checked');
    
    console.log('Filter:', filterType, filterValue, isChecked);
    
    // Add your filtering logic here
    // For production, consider using Shopify's built-in filtering or AJAX
  });

})(jQuery);
